import { APP_BASE_HREF, Location, ViewportScroller } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ApplicationStateFacade } from 'mbs-ui-shared/src/lib/facades/application.facade';
import { HelpService } from 'mbs-ui-shared@help/help.service';

@UntilDestroy()
@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
  frameUrl: SafeResourceUrl;
  baseHref: string;
  hasFooter = false;

  constructor(
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private location: Location,
    private viewportScroll: ViewportScroller,
    @Inject(APP_BASE_HREF) href,
    private appFacade: ApplicationStateFacade,
    private helpService: HelpService
  ) {
    this.baseHref = href;
  }

  ngOnInit() {
    const pageName = this.location.path(true).replace('/AP/Help', '');

    this.frameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.helpService.getHelpLink(pageName));

    this.appFacade.selectFooterExist$.pipe(untilDestroyed(this)).subscribe((value) => (this.hasFooter = value));
  }

  @HostListener('window:message', ['$event']) message(event) {
    if (event.data.path) {
      this.location.replaceState(`/AP/Help/${event.data.path.slice(1)}`);
    }

    if (event.data.title) {
      this.titleService.setTitle(event.data.title);
    }

    if (event.data.externalUrl) {
      window.open(event.data.externalUrl, '_blank');
    }

    if (event.data.anchorOffsetTop) {
      this.viewportScroll.scrollToPosition([0, event.data.anchorOffsetTop]);
    }
  }
}
